import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { CalendarEvent } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { createShallowStore, createStore } from '@frontend/store';
import { ExtendedAppointment } from '../types';

type AppointmentEventCardStoreType = {
  isIntegratedOffice: boolean;
  appointmentDetails:
    | (Appointment & Pick<CalendarEvent, 'referenceId' | 'displayOptions'> & { appointmentTypeId?: string })
    | null;
  setIsIntegratedOffice: (isIntegratedOffice: boolean) => void;
  setAppointmentDetails: (appointmentDetails: ExtendedAppointment | null) => void;
  closeAppointmentDetailsModal?: () => void;
  setCloseAppointmentDetailsModal: (closeAppointmentDetailsModal: () => void) => void;
};

const useAppointmentEventCardStore = createStore<AppointmentEventCardStoreType>(
  (set) => ({
    isIntegratedOffice: false,
    appointmentDetails: null,
    setIsIntegratedOffice: (isIntegratedOffice) => set({ isIntegratedOffice }),
    setAppointmentDetails: (appointmentDetails) => set({ appointmentDetails }),
    setCloseAppointmentDetailsModal: (closeAppointmentDetailsModal) => set({ closeAppointmentDetailsModal }),
  }),
  {
    name: 'AppointmentEventCardStore',
  }
);

export const useAppointmentEventCardShallowStore =
  createShallowStore<AppointmentEventCardStoreType>(useAppointmentEventCardStore);
